module.exports = "/packs/media/images/Travel-705a0dce52ad3637a0301c38307e13ad.png";